import { adminTrpc } from '@bitbot/api';
import { createStore } from 'hox';
import { useMemo, useState } from 'react';

export const [useInviteHistory, InviteHistoryProvider] = createStore(
  () => {
    const [isQueryRewards, setQueryRewards] = useState(false);
    const { data: inviteRecord, isLoading: isLoadingInviteRecord } =
      adminTrpc.invite.getInviteRecord.useQuery();
    const { data: rewards, isLoading: isLoadingRewards } =
      adminTrpc.claimReward.getRewards.useQuery(undefined, {
        enabled: isQueryRewards,
      });
    function queryRewards() {
      setQueryRewards(true);
    }
    return {
      inviteRecord,
      rewards,
      queryRewards,
      isLoadingInviteRecord,
      isLoadingRewards,
    };
  },
);
